// minicart
  // document.addEventListener("DOMContentLoaded", () => {
  //       const messages = document.querySelectorAll(
  //         ".minicart-announcement-bar__message"
  //       );
  //       const prevBtn = document.querySelector(
  //         ".minicart-announcement-bar__prev"
  //       );
  //       const nextBtn = document.querySelector(
  //         ".minicart-announcement-bar__next"
  //       );
  //       let currentIndex = 0;
  //       const cycleSpeed = 5000; // Change message every 5 seconds

  //       const showMessage = (index) => {
  //         messages.forEach((message, i) => {
  //           message.classList.toggle("active", i === index);
  //         });
  //       };

  //       const nextMessage = () => {
  //         currentIndex = (currentIndex + 1) % messages.length;
  //         console.log("currentIndex", currentIndex);
  //         showMessage(currentIndex);
  //       };

  //       const prevMessage = () => {
  //         currentIndex = (currentIndex - 1 + messages.length) % messages.length;
  //         showMessage(currentIndex);
  //       };

  //       nextBtn.addEventListener("click", nextMessage);
  //       prevBtn.addEventListener("click", prevMessage);

  //       let autoRotate = setInterval(nextMessage, cycleSpeed);

  //       // Pause autoplay on hover
  //       document
  //         .querySelector(".minicart-announcement-bar")
  //         .addEventListener("mouseover", () => {
  //           clearInterval(autoRotate);
  //         });

  //       document
  //         .querySelector(".minicart-announcement-bar")
  //         .addEventListener("mouseout", () => {
  //           autoRotate = setInterval(nextMessage, cycleSpeed);
  //         });

  //       // Initialize the first message as active
  //       showMessage(currentIndex);
  //     });

// second mini 
// document.addEventListener("DOMContentLoaded", () => {
//   const messages = document.querySelectorAll(
//     ".minicart-announcement-bar__message"
//   );
//   const prevBtn = document.querySelector(
//     ".minicart-announcement-bar__prev"
//   );
//   const nextBtn = document.querySelector(
//     ".minicart-announcement-bar__next"
//   );
//   const announcementBar = document.querySelector(".minicart-announcement-bar");

//   let currentIndex = 0; // Current active message index
//   const cycleSpeed = 5000; // Time (ms) between automatic transitions
//   let autoRotate; // Store interval reference

//   // Function to show the message at the given index
//   const showMessage = (index) => {
//     messages.forEach((message, i) => {
//       message.classList.toggle("active", i === index); // Add 'active' class to the current message
//     });
//   };

//   // Function to go to the next message
//   const nextMessage = () => {
//     currentIndex = (currentIndex + 1) % messages.length; // Cycle through messages
//     showMessage(currentIndex);
//   };

//   // Function to go to the previous message
//   const prevMessage = () => {
//     currentIndex = (currentIndex - 1 + messages.length) % messages.length; // Cycle backward
//     showMessage(currentIndex);
//   };

//   // Function to start auto-rotation
//   const startAutoRotate = () => {
//     stopAutoRotate(); // Prevent multiple intervals
//     autoRotate = setInterval(nextMessage, cycleSpeed);
//   };

//   // Function to stop auto-rotation
//   const stopAutoRotate = () => {
//     if (autoRotate) {
//       clearInterval(autoRotate);
//       autoRotate = null;
//     }
//   };

//   // Attach click event listeners to buttons
//   if (nextBtn) {
//     nextBtn.addEventListener("click", () => {
//       stopAutoRotate(); // Stop auto-rotation on manual interaction
//       nextMessage();
//       startAutoRotate(); // Restart auto-rotation
//     });
//   }

//   if (prevBtn) {
//     prevBtn.addEventListener("click", () => {
//       stopAutoRotate(); // Stop auto-rotation on manual interaction
//       prevMessage();
//       startAutoRotate(); // Restart auto-rotation
//     });
//   }

//   // Pause auto-rotation on hover
//   if (announcementBar) {
//     announcementBar.addEventListener("mouseover", stopAutoRotate);
//     announcementBar.addEventListener("mouseout", startAutoRotate);
//   }

//   // Initialize the first message as active
//   showMessage(currentIndex);

//   // Start auto-rotation
//   startAutoRotate();

//   // Debugging log
//   console.log("Announcement bar initialized and auto-rotation started.");
// });


// start page catalogues button 
  document.querySelectorAll('.download-btn').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      const url = btn.getAttribute('href');
      const filename = url.substring(url.lastIndexOf('/') + 1);
      const getIndex = filename.indexOf(".pdf");
      const newFileName = filename.substring(0, getIndex);
      download(url, newFileName);
    });
  });

  function download(url, result) {
    fetch(url).then(function (response) {
      return response.blob().then(function (blob) {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.setAttribute('download', result);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    });
  }
// end page catalogues button 


/* Open INDUSTRIAL menu in new tab */
// Guarded (2 Nov 2026): the link is no longer on the page; the unguarded call threw and stopped the rest of this file (slider, before/after toggle).
document.querySelectorAll('a[href="https://www.vetropoweramc.com/"]').forEach(function (el) { el.setAttribute('target', '_blank'); });
/* Open INDUSTRIAL link of the footer in new tab */


// start read more function 
    $(document).ready(function () {
      $(".read").click(function () {
        $(this).prev().toggle();
        $(this).siblings('.dots').toggle();
        if ($(this).text() == 'read more') {
          $(this).text('read less');
        }
        else {
          $(this).text('read more');
        }
      });
    });
// end read more function

// start Accordion function
  $('.head').click(function () {
      $(this).toggleClass('active');
      $(this).parent().find('.arrow').toggleClass('arrow-animate');
      $(this).parent().find('.content').slideToggle(280);
    });

// end

// start tutorials page filter 
 $(document).ready(function () {
    $('#categoryFilter, #colorFilter').change(filterItems);
  });

  function filterItems() {
    var category = $('#categoryFilter').val();
    var color = $('#colorFilter').val();

    $('.item').each(function () {
      var $this = $(this);
      var itemCategory = $this.data('category');
      var itemColor = $this.data('color');

      var categoryMatch = (category === '' || itemCategory === category);
      var colorMatch = (color === '' || itemColor === color);

      if (categoryMatch && colorMatch) {
        $this.removeClass('hidden');
      } else {
        $this.addClass('hidden');
      }
    });
  }
// end tutorials page filter 

// start slider

 $('.sliderrp').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

// end slider

 $(document).ready(function() {
    // Set the "Before" button as active by default
    $("#before-button").addClass("active");
    $("#before-image").show();
    
    // Click event for the "Before" button
    $("#before-button").click(function() {
        $(this).addClass("active");
        $("#after-button").removeClass("active");
        $("#before-image").show();
        $("#after-image").hide();
    });
    
    // Click event for the "After" button
    $("#after-button").click(function() {
        $(this).addClass("active");
        $("#before-button").removeClass("active");
        $("#before-image").hide();
        $("#after-image").show();
    });
});

// 

 $(document).ready(function() {
  if($('.product__info.enq_form').length >= 1){
    var $divToMove = $(".product-form__custom-liquid").detach();
    $divToMove.insertAfter("#enquire_btn");
    $('.product-form__custom-liquid').css('width', '100%');
    $('.product-form__custom-liquid').css('padding-top', '25px');
    $('.product-form__custom-liquid').show();
  }
 });


// start dealers
function updateContent() {
    var stateSelector = document.getElementById("stateSelector");
    var selectedState = stateSelector.value;

    // Hide all state content divs
    var allStateDivs = document.querySelectorAll(".state");
    allStateDivs.forEach(function (stateDiv) {
      stateDiv.style.display = "none";
    });

    // Show the selected state content or all states content
    var selectedStateDiv = document.getElementById(selectedState + "Content");
    if (selectedState === "all") {
      allStateDivs.forEach(function (stateDiv) {
        stateDiv.style.display = "block";
      });
    } else if (selectedStateDiv) {
      selectedStateDiv.style.display = "block";
    }
  }

  // Call the updateContent function on page load to show content for all states
  updateContent();
// end dealers





